import { css, keyframes } from 'styled-components';
var hoverPop = function hoverPop() {
  var maxScale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1.05;
  return keyframes(["0%{transform:scale(0.9);}50%{transform:scale(", ");}"], maxScale);
};
export var hoverPopAnimation = css(["animation:", " 0.2s ease-in;"], hoverPop);